<template>
  <v-list-tile
    :key="notification.friendName"
    class="mt-1"
    :style="notification.new ? styleNew : ''"
    avatar
    :to="'/profile/' + notification.uniqueId"
    
    @click.native="changeNotificationNew(notification)">
    <v-list-tile-avatar style="margin: auto">
      <img :src="notification.friendProfileImg">
    </v-list-tile-avatar>

    <v-list-tile-content>
      <!-- TODO: Text/Translate -->

      <v-list-tile-title>
        Freundschaftsanfrage
        <span class="caption font-italic secondary--text">
          - {{ notification.requestTime | dateShort }}
        </span>
      </v-list-tile-title>
                   
      <v-list-tile-sub-title 
        style="overflow: hidden; white-space: nowrap;">
        <v-icon 
          small 
          class="mr-1">
          fas fa-user
        </v-icon>
        {{ notification.friendName }} <span class="caption grey--text font-italic">
          <v-icon size="14">
            fas fa-fingerprint
          </v-icon> {{ notification.uniqueId }}
        </span>
      </v-list-tile-sub-title>
      
      <v-list-tile-sub-title 
        style="overflow: hidden; white-space: nowrap;" 
        class="caption font-italic">
        {{ notification.friendStatus }}
      </v-list-tile-sub-title>
    </v-list-tile-content>

    <v-list-tile-action>
      <!-- <div style="white-space: nowrap;"> -->
     
      <v-btn
        class="mx-1"
        small
        :color="notification.new ? 'blue darken-1' : 'white'"
        :dark="notification.new"
        :depressed="!notification.new"
        fab>
        <v-icon small>
          fas fa-user-tag
        </v-icon>
        <!-- <v-icon small>
          fas fa-times
        </v-icon> -->
      </v-btn>
        
      <!-- <v-btn 
          class="mx-1"
          depressed
          
          height="10"
          fab 
          color="green"
          dark
          small>
          <v-icon>fas fa-account-check</v-icon>
        </v-btn>
        <v-btn 
          class="mx-1"
          depressed
          
          fab 
          color="red"
          dark
          small>
          <v-icon>fas fa-account-remove fas fa-flip-h</v-icon>
        </v-btn> -->
      <!-- </div> -->
                    
      <!-- <v-list-tile-action-text>noth</v-list-tile-action-text> -->
      <!-- <v-icon
                      v-if="selected.indexOf(index) < 0"
                      color="grey lighten-1"
                      @click="toggle(index)">
                      star_border
                    </v-icon>
                  

                    <v-icon
                      v-else
                      color="yellow darken-2"
                      @click="toggle(index)">
                      star
                    </v-icon> -->
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    notification: { type: Object, default: null }
  },
  data() {
    return { 
      fab: false,

      styleNew: {
        'background-color': 'rgba(236,239,241,0.7)'
        // 'background-color': '#ECEFF1'
      },
    }
  },
  methods: {
    ...mapActions([
      'changeNotification',
      
    ]),
    changeNotificationNew(notification) {
      if (notification.new === true) {
        console.log('nnn', notification)
        this.changeNotification(notification)
      }
      
     
    },
  }
}
</script>
